module.exports = __webpack_public_path__ + "img/kxyz.9af39bdf.jpg";